import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, mergeMap, exhaustMap } from 'rxjs/operators';
import { ActionTypes } from '@appStore/account/actions';
import * as actions from '@appStore/account/actions';
import { WidgetService, SettingsService } from '@appStore/account/services';

@Injectable()
export class WidgetEffects {
  constructor(
    private router: Router,
    private widgetService: WidgetService,
    private settingsService: SettingsService,
    private actions$: Actions
  ) {}

  widgetDataLoad$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.WidgetDataLoad),
      map((action: actions.WidgetDataLoad) => action.payload),
      mergeMap(action => {
        return this.widgetService.load(action).pipe(
          map(payload => new actions.WidgetDataLoadSuccess({ data: payload, meteringType: action.meteringType })),
          catchError(error => of(new actions.WidgetDataLoadFail({ error: error, widgetLoadConfig: action })))
        );
      })
    );
  });

  loadAvailableWidgets$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.AvailableWidgetsLoad),
      map((action: actions.AvailableWidgetsLoad) => action),
      mergeMap(action => {
        return this.widgetService.getAvailableWidgets().pipe(
          map(payload => new actions.AvailableWidgetsLoadSuccess(payload)),
          catchError(error => of(new actions.AvailableWidgetsLoadFail(error)))
        );
      })
    );
  });
  
  updateWidgetSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.WidgetSettingUpdate),
      map((action: actions.WidgetSettingUpdate) => action.payload),
      exhaustMap(widgetSettings => {
        return this.settingsService.updateWidgetSettings(widgetSettings).pipe(
          map(settings => new actions.WidgetSettingUpdateSuccess(settings)),
          catchError(error => of(new actions.WidgetSettingUpdateFail(error)))
        );
      })
    );
  });
}
